export const overflowMui = () => {
  return {
    overflowY: 'scroll',
    '&::-webkit-scrollbar': { width: '8px' },
    '&::-webkit-scrollbar-thumb': { backgroundColor: '#888', borderRadius: '4px' },
    '&::-webkit-scrollbar-thumb:hover': { backgroundColor: '#555' },
  };
};
